import { render, staticRenderFns } from "./AddTruckModal.vue?vue&type=template&id=089d6208&scoped=true"
import script from "./AddTruckModal.vue?vue&type=script&lang=js"
export * from "./AddTruckModal.vue?vue&type=script&lang=js"
import style0 from "./AddTruckModal.vue?vue&type=style&index=0&id=089d6208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089d6208",
  null
  
)

export default component.exports